<template>
  <div class="about">
    <h2>Transfer Pilots To New Date</h2>
    <v-card outlined raised max-width="300">
      <v-label>Select from date and to date.</v-label>
      <v-date-picker v-model="dates" range></v-date-picker>
      <v-row>
        <!-- v-if="dates.length==1" -->
        <v-col></v-col>
        <v-chip color="primary" >{{ dates[0] }}</v-chip>
        <v-chip color="primary" >{{ dates[1] }}</v-chip>
        <v-col></v-col>
      </v-row>
      <div>.</div>

      <!-- <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="fromDate"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="fromDate"
            label="From date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="fromDate" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(fromDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="toDate"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="toDate"
            label="To date"
            prepend-icon="mdi-calendar"
            readonly
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="toDate" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="$refs.dialog.save(toDate)">
            OK
          </v-btn>
        </v-date-picker>
      </v-dialog> -->
      <v-spacer></v-spacer>
      <v-row justify="center">
        <v-col></v-col>
        <v-col>
          <v-btn color="primary" @click="transfer" :disabled="transferDisabled"
            >Transfer</v-btn
          >
        </v-col>
        <v-col>
          <v-btn link :to="cancellink.to">Cancel</v-btn>
        </v-col>
        <v-col></v-col>
      </v-row>
      <div>.</div>
      <v-alert type="success" :value="isAlertVisible" dense>
        {{ statusResultMsg }}
        <div>.</div>
        <v-btn link :to="cancellink.to">OK</v-btn>
      </v-alert>
      <v-alert type="error" :value="isWarningAlertVisible" dense>
        {{ statusResultMsg }}
        <div>.</div>
        <v-btn link :to="cancellink.to">OK</v-btn>
      </v-alert>
    </v-card>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "Transfer",
  props: {
    box: [],
    regId: Number,
    ac: String,
  },
  // regid: Number,
  data() {
    return {
      //   eyevalueac: true,
      //   eyevaluepw: true,
      //   isValid: true,
      //   regidRules: [(v) => !!v || "User is required"],
      //   acRules: [(v) => !!v || "Access code is required"],
      //   pwRules: [(v) => !!v || "Password is required"],
      //   cancellink: { to: "/checkin" },
      cancellink: { to: "/" },
      isAlertVisible: false,
      isWarningAlertVisible: false,
      statusResult: Number,
      statusResultMsg: String,
      transferDisabled: false,
      //   cancelBtnText: "",
      //   statuses: [],
      //   errors: [],
      //   snackbar: false,
      //   snackbartext: "No info.",
      //   loginModel: null,

      fromDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      toDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      modal: false,
      menu2: false,
      dates: [],
    };
  },
  created() {
    //this.baseUrl = "http://localhost:3000/dbapi/";
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.regid = null;
    // this.isValid = false;
    // this.ac = null;
    // this.pw = null;
  },
  methods: {
    transfer() {
      var regId = this.regId;
      var ac = this.ac;
      var eventId = this.box.EventId;

      // var fromDate = this.fromDate;
      // var toDate = this.toDate;
      var fromDate = this.dates[0]; //this.fromDate;
      if (this.dates.length < 1) {
        fromDate = this.fromDate;
      }
      var toDate = this.dates[1]; //this.toDate;
      if (this.dates.length < 2 || this.dates.length == 1) {
        toDate = fromDate;
      }

      var toSubmit = JSON.stringify({ regId, ac, eventId, fromDate, toDate });
      const uri = this.baseUrl + "transferRegToDate";
      //console.log(toSubmit);
      this.sendpost(uri, toSubmit, 1);
    },

    sendpost(uri, toSubmit, type) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          if (type === 0) {
            this.statusResult = response.data.Result;
            this.statusResultMsg = response.data.ResultMsg;
          } else {
            this.statusResult = response.data[0].Result;
            this.statusResultMsg = response.data[0].ResultMsg;
          }
          if (this.statusResult == 1) {
            this.cancelBtnText = "Done";
            console.log(response.data);
          }
          this.setAlert(this.statusResult);
          //   if (this.statusResult === 1) {
          //       getstatus();
          //   }
        })
        .catch((e) => {
          this.errors.push(e);
          this.statusResult = 0;
          this.statusResultMsg = "Something went wrong!";
          this.setAlert(this.statusResult);
        });
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
      this.transferDisabled = true;
    },
  },
};
</script>